module.exports = __webpack_public_path__ + "assets/8b14c6db66ca1f640751838c167d1261.png";